import React, {useState} from "react";
import { connect } from "react-redux";
import { settipomisure, setopenmain } from "../../state/actions";

import MisuraSlider from "../misuraslider";
import MisuraDaTaglia from "../misuradataglia";
import MisuraInvia from "../misurainvia";
import MisuraTeletta from "../misurateletta";

import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import Drawer from "@mui/material/Drawer";

const Misure = (props) => {
  const { lingua, tipo, setTipoMisure, setOpenMain, openMain} = props;

  const [aperto, setAperto] = useState(false);

  let misu = <MisuraDaTaglia lingua={lingua} />

  switch(tipo) {
    case 0:
      misu = <MisuraDaTaglia lingua={lingua} />
      break;
    case 1:
      misu = <MisuraSlider lingua={lingua} tipo="corpo" />
      break;
    case 2:
      misu = <MisuraSlider lingua={lingua} tipo="camicia" />
      break;
    case 3:
      misu = <MisuraInvia lingua={lingua} />
      break;
      case 4:
        misu = <MisuraTeletta lingua={lingua} />
        break;
    default:
      misu = <MisuraDaTaglia lingua={lingua} />
  }

  return (
    <>
      <Drawer
        anchor={"left"}
        open={aperto}
        onClose={() => setAperto(false)}
        hideBackdrop={true}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          zIndex: 10000,
          width: 260,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: 260,
            boxSizing: "border-box",
          },
        }}
      >
        <div className="p-3">
          <button
            className="button is-small is-white is-pulled-right"
            onClick={() => setAperto(false)}
          >
            <span className="icon">
              <CloseIcon />
            </span>
          </button>
        </div>

        <aside
          className="menu"
          style={{
            height: "calc(100vh - 3rem)",
            overflowY: "scroll",
            padding: "0 1.5rem 1.5rem 1.5rem",
          }}
        >
          <div className="menu-list">
            <button
              style={{ fontSize: "1rem", textAlign:"left" }}
              className={
                tipo === 0
                  ? "buttonLink panel-block has-text-primary"
                  : "buttonLink panel-block"
              }
              onClick={() => {
                setTipoMisure(0);
                setAperto(false);
                
              }}
            >
              {lingua.navigazione.misure.metodoTaglia}
            </button>

            
            <button
              style={{ fontSize: "1rem", textAlign:"left" }}
              className={
                tipo === 1
                  ? "buttonLink panel-block has-text-primary"
                  : "buttonLink panel-block"
              }
              onClick={() => {
                setTipoMisure(1);
                setAperto(false);
                
              }}
            >
              {lingua.navigazione.misure.metodoCorpo}
            </button>

            <button
              style={{ fontSize: "1rem", textAlign:"left" }}
              className={
                tipo === 2
                  ? "buttonLink panel-block has-text-primary"
                  : "buttonLink panel-block"
              }
              onClick={() => {
                setTipoMisure(2);
                setAperto(false);
                
              }}
            >
              {lingua.navigazione.misure.metodoCamicia}
            </button>

            <button
              style={{ fontSize: "1rem", textAlign:"left" }}
              className={
                tipo === 3
                  ? "buttonLink panel-block has-text-primary"
                  : "buttonLink panel-block"
              }
              onClick={() => {
                setTipoMisure(3);
                setAperto(false);
                
              }}
            >
              {lingua.navigazione.misure.metodoInvia}
            </button>

            
            
            </div>
            
          
        </aside>
      </Drawer>



      <Drawer
        anchor={"left"}
        open={openMain}
        onClose={() => setOpenMain(false)}
        hideBackdrop={true}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          width: 320,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: 320,
            boxSizing: "border-box",
          },
        }}
      >
        <div className="p-3">
          <button
            className="button is-small is-white"
            onClick={() => setAperto(true)}
          >
            <span className="icon">
              <MenuIcon />
            </span>
            <span className="ml-2">Clicca sulle tre lineette per inserire le misure</span>
          </button>

          <button
            className="button is-small is-white is-pulled-right"
            onClick={() => setOpenMain(false)}
          >
            <span className="icon">
              <CloseIcon />
            </span>
          </button>
        </div>

        <div
          style={{ height: "calc(100vh - 3rem)", overflowY: "scroll" }}
          
        >
          <div style={{padding: "0 1.5rem 1.5rem 1.5rem"}}>
          {misu}
          </div>
        </div>
      </Drawer>





      
        <div className="container-features" style={{ background: "#fff" }}>
          <div className="p-3">
            <button
              className="button is-small is-white"
              onClick={() => setAperto(true)}
            >
              <span className="icon">
                <MenuIcon />
              </span>
              <span className="ml-2">Clicca sulle tre lineette per inserire le misure</span>
            </button>
          </div>

          <div style={{ height: "calc(100vh - 6.6rem)", overflowY: "scroll" }}>
            <div
              className="section"
              style={{ padding: "0 1.5rem 1.5rem 1.5rem" }}
            >
              {misu}
            </div>
          </div>
        </div>
      
    </>
  );
};

function mapStateToProps(state) {
  return {
    tipo: state.shop.camicia.misure.tipo,
    openMain: state.shop.openMain,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setTipoMisure: (val) => dispatch(settipomisure(val)),
    setOpenMain: (val) => dispatch(setopenmain(val)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Misure);
